import React from 'react';
import globals from '../globals';

const FeatureItem = (props) => {

	const slug = globals.slugify(props.title);

	return (
		<div className="feature-item">
			<div>
				<img src={`/images/voip-banter/${slug}.svg`} alt={slug} />
				<span dangerouslySetInnerHTML={{__html: props.title}} />
			</div>
		</div>
	);

};

export default FeatureItem;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/FeatureItem.js